import { agentLocationStreetDirections } from '@cloud-wave/neon-common-lib';

import US_STATES from 'lib/common/constants/us-states.json';

export const myLocationFormFields = [
  {
    name: 'location.streetNumber',
    label: 'House Number',
    type: 'TEXT',
  },
  {
    name: 'location.streetDirection',
    label: 'Street Direction  •  Optional',
    required: false,
    type: 'SELECT',
    options: agentLocationStreetDirections.map((direction) => ({ label: direction, value: direction })),
  },
  {
    name: 'location.streetInfo',
    label: 'Street Name',
    placeholder: 'Includes suffix e.g. Main St',
    type: 'TEXT',
  },
  {
    name: 'location.unitNumber',
    label: 'Address Line 2  •  Optional',
    placeholder: 'Unit, apartment, suite, building, etc.',
    required: false,
    type: 'TEXT',
  },
  {
    name: 'location.city',
    label: 'City',
    type: 'TEXT',
  },
  {
    name: 'location.state',
    label: 'State',
    type: 'SELECT',
    placeholder: 'Select a state...',
    options: US_STATES,
  },
  {
    name: 'location.postalCode',
    label: 'Zip / Postal Code',
    type: 'TEXT',
  },
];
